
<div>
  <button @click.stop="open" ref="button" class="dropdown-toggle btn-icon clear-area controllers" :id="`moreActionsButton_${model.client_id}`" type="button">
    <icon class="kebab"></icon>
    <span class="sr-only">More Actions Dropdown</span>
  </button>

  <context-menu ref="contextMenu"
                :state="modalStateFor(vueModalID.sortableContextMenu)"
                :index="vueModalID.sortableContextMenu"
                fixed
                @close="toggleModal">
    <ul>
      <li v-if="!model.isFirst">
        <button ref="up" @click.stop="move('up')" @keyup.enter="move('up', true)" class="dropdown-item">Move Up</button>
      </li>
      <li v-if="!model.isLast">
        <button ref="down" @click.stop="move('down')" @keyup.enter="move('down', true)" class="dropdown-item">Move Down</button>
      </li>
      <li v-if="model.check_by_default">
        <button @click.stop="uncheckItem" class="dropdown-item">Clear as default</button>
      </li>
      <li>
        <button @click.stop="deleteItem" class="dropdown-item">Delete</button>
      </li>
    </ul>
  </context-menu>
</div>
